import React from 'react';
import './styles/TextInput.scss';

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

const TextInput: React.FC<TextInputProps> = ({ value, onChange, placeholder = '', className = '' }) => {
  const handleChange = (value: string) => {
    onChange(value);
  };

  return (
    <div className={`text-input ${className}`}>
      <input
        type='text'
        className='text-input__field'
        value={value}
        onChange={(e) => {
          e.stopPropagation();
          handleChange(e.target.value);
        }}
        onClick={(e) => e.stopPropagation()}
        placeholder={placeholder}
      />
    </div>
  );
};

export default TextInput;
